/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HandleStripeWebhook200Response
 */
export interface HandleStripeWebhook200Response {
    /**
     * 
     * @type {boolean}
     * @memberof HandleStripeWebhook200Response
     */
    received: boolean;
}

/**
 * Check if a given object implements the HandleStripeWebhook200Response interface.
 */
export function instanceOfHandleStripeWebhook200Response(value: object): value is HandleStripeWebhook200Response {
    if (!('received' in value) || value['received'] === undefined) return false;
    return true;
}

export function HandleStripeWebhook200ResponseFromJSON(json: any): HandleStripeWebhook200Response {
    return HandleStripeWebhook200ResponseFromJSONTyped(json, false);
}

export function HandleStripeWebhook200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandleStripeWebhook200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'received': json['received'],
    };
}

export function HandleStripeWebhook200ResponseToJSON(json: any): HandleStripeWebhook200Response {
    return HandleStripeWebhook200ResponseToJSONTyped(json, false);
}

export function HandleStripeWebhook200ResponseToJSONTyped(value?: HandleStripeWebhook200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'received': value['received'],
    };
}

